import { Lightning, AppData } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';
import { getImageTextureObj } from 'support/generalUtils';
import { getFontFaceFromStyle } from 'support/textUtils';
import { translate } from 'support/translate';

export interface LoggedOutProfileTemplateSpec
  extends Lightning.Component.TemplateSpec {
  ProfileIcon: typeof Lightning.Texture;
  EmailText: typeof TextLabel;
}

const SECTION_WIDTH = 640;
const PROFILE_HEIGHT = 178;
const ICON_SIZE = 114;
const VERTICAL_SPACE_LARGE = 24;
const VERTICAL_SPACE_SMALL = 8;
const EMAIL_FONT_SIZE = 22;

export default class LoggedOutProfile
  extends Lightning.Component<LoggedOutProfileTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<LoggedOutProfileTemplateSpec>
{
  private _ProfileIcon = this.getByRef('ProfileIcon')!;
  private _EmailText = this.getByRef('EmailText')!;
  static override _template(): Lightning.Component.Template<LoggedOutProfileTemplateSpec> {
    const profileIcon = getImageTextureObj(
      'static/images/profile-icon.svg',
      ICON_SIZE,
      ICON_SIZE,
    );

    return {
      w: SECTION_WIDTH,
      h: PROFILE_HEIGHT,
      flex: {
        direction: 'column',
        alignItems: 'center',
      },
      flexItem: {
        marginBottom: VERTICAL_SPACE_LARGE,
      },
      ProfileIcon: {
        ...profileIcon,
        flexItem: {
          marginTop: VERTICAL_SPACE_SMALL,
          marginBottom: VERTICAL_SPACE_LARGE,
        },
      },
      EmailText: {
        type: TextLabel,
        text: {
          advancedRenderer: true,
          fontSize: EMAIL_FONT_SIZE,
          fontFace: getFontFaceFromStyle('regular'),
        },
      },
    };
  }

  override _active(): void {
    const account = AppData?.loginRadiusService?.getAccount();
    if (account) {
      this._EmailText.patch({
        text: translate(
          'settings.LoggedInProfile.SignedInEmail',
          account.primaryEmail,
        ),
      });
    }
  }
}
